//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { usePurchaseOptionsContext } from '@campaigns/components/shared/purchase-options/PurchaseOptionsContext';

import { PrepaidPurchaseOptionsTableRowEditable } from './PrepaidPurchaseOptionsTableRowEditable';
import { PrepaidPurchaseOptionsTableRowReadOnly } from './PrepaidPurchaseOptionsTableRowReadOnly';

interface PrepaidPurchaseOptionsTableRowProps {
  purchaseOption: PurchaseOption;
}

export const PrepaidPurchaseOptionsTableRow = ({
  purchaseOption,
}: PrepaidPurchaseOptionsTableRowProps) => {
  const { readOnly } = usePurchaseOptionsContext();

  return readOnly ? (
    <PrepaidPurchaseOptionsTableRowReadOnly purchaseOption={purchaseOption} />
  ) : (
    <PrepaidPurchaseOptionsTableRowEditable purchaseOption={purchaseOption} />
  );
};
